import React from 'react';
import { get, isEmpty } from 'lodash-es';
import T from 'prop-types';

import skeletons from './Skeletons';
import Screenshots from '../Screenshots';

const InsightsSlider = ({ details, settings, store, open }) => {
  if (settings.pending) return skeletons.detailsSlider;

  const screenshotUrls = get(details, 'app_about.about_data.screenshot_urls', []);
  const screenshotCDNs = get(details, 'app_about.about_data.screenshot_cdn_paths', []);
  const screenshots = !isEmpty(screenshotCDNs) ? screenshotCDNs : screenshotUrls;
  if (!settings.pending && (!screenshots || !screenshots.length)) return null;

  return (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">Screenshots</h4>
      <div className="insights-details-block__content">
        <Screenshots
          open={open}
          screenshots={screenshots}
          store={store}
        />
      </div>
    </div>
  );
};

InsightsSlider.propTypes = {
  details: T.object,
  settings: T.object,
  store: T.string,
  open: T.bool,
};

export default InsightsSlider;
